import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Card, { CardContent, CardMedia } from 'material-ui/Card';

class ProfileImage extends Component {
  render(){
    const { classes, theme, location, data } = this.props;

    let profile_url = "http://www.lrcsolutions.com/images/" + data["access id"] + "/" + data["Pic1"];

    return(
      <div>
        <CardMedia
          className={classes.cover}
          image={profile_url}
          title="Live from space album cover"
        />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(ProfileImage);



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/ActionsDrawer/components/CandidateItem/components/ProfileImage/index.js